const appName = 'Bazar';

export default function Strings() {
	return {
		appName,
		Login: 'Login',
		Signup: 'Signup',
	}
}